export enum Tab {
	FOLLOWING_POST = 'FOLLOWING_POST',
	NOTIFICATION = 'NOTIFICATION',
	EXPLORE_POST = 'EXPLORE_POST',
	USER_PROFILE = 'USER_PROFILE',
	MORE = 'MORE',
}
